// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"actual-content_wrapper__g3WsV"};